import { render, staticRenderFns } from "./settlementTab.vue?vue&type=template&id=3f0db6a6&scoped=true&"
import script from "./settlementTab.vue?vue&type=script&lang=js&"
export * from "./settlementTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0db6a6",
  null
  
)

export default component.exports